var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-toolbar',{staticClass:"mb-3",attrs:{"dense":"","dark":_vm.dark,"flat":"","color":"amber lighten-2"}},[_c('v-toolbar-title',{staticClass:"subtitle-2 font-weight-bold black--text"},[_vm._v(" "+_vm._s(_vm.title)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }